import Immutable from 'immutable'
import * as actionTypes from '../../actionTypes'
import * as requestTypes from '../requestTypes'
import { Transaction } from '../../data/Transaction'

type TransactionStateProps = {
    displayMessage: string | null
    processing: Transaction | null
    result: Transaction | null
}

const TransactionStateRecord = Immutable.Record({
    displayMessage: null,
    processing: null,
    result: null,
})

export class TransactionState extends TransactionStateRecord implements Readonly<TransactionStateProps>
{
    // displayMessage: string | null
    // processing: Transaction | null
    // result: Transaction | null
}

const processRequest = (state, request) => {
    if (request.method === requestTypes.PURCHASE || request.method === requestTypes.REFUND) {
        const requestData = request.params ? request.params.external_data : null
        const requestTransaction = requestData ? new Transaction(requestData) : null

        if (requestTransaction && requestTransaction.id && requestTransaction.transactionType) {
            return setProcessing(state, requestTransaction)
        }
    }

    return state
}

const setProcessing = (state: TransactionState, transaction: Transaction) =>
    state
        .set('processing', transaction)
        .set('result', null)

const setResult = (state, transaction: Transaction) =>
    state
        .set('displayMessage', transaction.terminalResult && transaction.terminalResult.display_message ? transaction.terminalResult.display_message : state.displayMessage)
        .set('processing', null)
        .set('result', transaction)

export default function (state: TransactionState = new TransactionState(), action) {
    switch (action.type) {
        case actionTypes.PAYMENT_TERMINAL_CONNECT:
        case actionTypes.PAYMENT_TERMINAL_CONNECTED:
        case actionTypes.PAYMENT_TERMINAL_DISCONNECT:
        case actionTypes.PAYMENT_TERMINAL_DISCONNECTED:
            return new TransactionState()
        case actionTypes.PAYMENT_TERMINAL_SEND_REQUEST:
            return processRequest(state, action.request)
        case actionTypes.PAYMENT_TERMINAL_DISPLAY_MESSAGE_RECEIVED:
            return state.set('displayMessage', state.processing && action.message ? action.message.message : state.displayMessage)
        case actionTypes.PAYMENT_TERMINAL_TRANSACTION_COMPLETED:
            return setResult(state, action.result)
        case actionTypes.PAYMENT_TERMINAL_TRANSACTION_PROCESSING:
            return setProcessing(state, action.transaction)
    }

    return state
}
